import { supabase } from "@/integrations/supabase/client";

/** Public customer entry routes for the same Perfume Wizard and Corporate Gifting Wizard experiences. */
export const PUBLIC_PERFUME_WIZARD_ROUTE = "/perfume-wizard";
export const PUBLIC_CORPORATE_WIZARD_ROUTE = "/corporate-gifting-wizard";

export type WizardAudience = "staff" | "public";

/**
 * Public pages always call the wizard services as a public visitor (publishable key), even when someone
 * is signed in, so a public session never mixes with staff sessions or staff-only data.
 */
export function wizardInvoke(name: string, body: Record<string, unknown>, audience: WizardAudience) {
  return supabase.functions.invoke(name, audience === "public"
    ? { body, headers: { Authorization: `Bearer ${import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY}` } }
    : { body });
}
